import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const cmsTravelTypesBlockEntity: Entity = {
  model: model,
  repository: repository,
}

export default cmsTravelTypesBlockEntity
